import { Component, DestroyRef, inject, input, OnInit, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HotelFiltersService } from '@app/services/hotelfilters.service';

export interface RangeType {
    min: number;
    max: number;
}

@Component({
    selector: 'clever-recomcount',
    templateUrl: './recomcount.component.html',
    styleUrls: ['./recomcount.component.scss'],
    standalone: false
})
export class RecomcountComponent implements OnInit {
    minValue = input<number>(0);
    step = input<number>(10);
    maxValue = input<number>(500);
    // currency = input<string>('');
    output = output<RangeType>();

    min = signal<number>(0);
    minValue_t = signal<number>(0);
    maxValue_t = signal<number>(500);
    max = signal<number>(500);

    minPercent = signal<number>(0);
    maxPercent = signal<number>(0);
    rangeWidth = signal<number>(0);

    destroyRef = inject(DestroyRef);

    constructor(protected hotelService: HotelFiltersService) { }

    ngOnInit(): void {
        this.minValue_t.set(this.minValue() ? this.minValue() : this.min());
        this.maxValue_t.set(this.maxValue() ? this.maxValue() : this.max());

        this.initFilterSub();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: any) => {
            this.minValue_t.set(filter.recommendationcount ? filter.recommendationcount : 0);
            this.updateRange(this.minValue_t(), this.maxValue_t());
        });
    }

    updateRange(tminValue, tmaxValue) {
        this.minValue_t.set(tminValue);
        this.maxValue_t.set(tmaxValue);
        if (this.minValue_t() > this.maxValue() - this.step()) {
            this.minValue_t.set(this.maxValue() - this.step());
        }

        if (this.maxValue_t() < this.minValue() + this.step()) {
            this.maxValue_t.set(this.minValue() + this.step());
        }

        this.minPercent.set((this.minValue_t() / this.max()) * 100);
        this.maxPercent.set((this.maxValue_t() / this.max()) * 100);
        this.rangeWidth.set(this.maxPercent() - this.minPercent());

    }

    async sendValue() {
        // this.output.emit({ min: this.minValue_t(), max: (this.maxValue_t() === this.max() ? null : this.maxValue_t()) });
        this.hotelService.recommendationcount(this.minValue_t(), true);
    }
}
